import React, { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import AdminSidebar from '../components/admin/AdminSidebar';
import AdminOverview from '../components/admin/AdminOverview';
import UserManagement from '../components/admin/UserManagement';
import PaymentManagement from '../components/admin/PaymentManagement';
import ListingsManagement from '../components/admin/ListingsManagement';
import RentalActivity from '../components/admin/RentalActivity';
import Analytics from '../components/admin/Analytics';
import PlatformSettings from '../components/admin/PlatformSettings';

const AdminDashboard = () => {
  const [activeTab, setActiveTab] = useState('overview');

  const renderContent = () => {
    switch (activeTab) {
      case 'overview':
        return <AdminOverview />;
      case 'users':
        return <UserManagement />;
      case 'payments':
        return <PaymentManagement />;
      case 'listings':
        return <ListingsManagement />;
      case 'rentals':
        return <RentalActivity />;
      case 'analytics':
        return <Analytics />;
      case 'settings':
        return <PlatformSettings />;
      default:
        return <AdminOverview />;
    }
  };

  return (
    <>
      <Helmet>
        <title>Admin Dashboard - VestrioZ</title>
        <meta
          name="description"
          content="VestrioZ admin dashboard for managing users, listings, and platform settings."
        />
        <meta name="keywords" content="admin, dashboard, management, VestrioZ" />
      </Helmet>
      <div className="min-h-screen flex" style={{ backgroundColor: '#DFD0B8' }}>
        <div className="flex w-full">
          {/* Sidebar */}
          <AdminSidebar activeTab={activeTab} setActiveTab={setActiveTab} />

          {/* Main Content */}
          <div className="flex-1 flex justify-center overflow-x-hidden">
            <div className="w-full max-w-6xl p-3 sm:p-4 lg:p-6 xl:p-8 pt-16 lg:pt-6">
              <div className="w-full overflow-x-auto">
                {renderContent()}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AdminDashboard;